import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Popconfirm, Table} from "antd";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import Colors from "../../../styles/Colors";
import {BiRefresh, BiTrash} from "react-icons/bi";
import RebutAlgoritmixModel from "../../../model/multilleure/RebutAlgoritmixModel";
import {BsCurrencyEuro, BsFilePdf} from "react-icons/bs";
import {PostRemesaDocument} from "../../../dao/multilleure/PostRemesaDocument";
import {PostRemesaFacturaAlgoritmix} from "../../../dao/multilleure/PostRemesaFacturaAlgoritmix";
import {GetRemeses} from "../../../dao/multilleure/administracio/GetRemeses";
import {DeleteRemesa} from "../../../dao/multilleure/administracio/DeleteRemesa";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {PostRemesaFactura} from "../../../dao/multilleure/PostRemesaFactura";

const Remeses = () => {
    const titol: string = "Remeses";

    const {isLoggedIn, userId, user, page, token} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [documentUrl, setDocumentUrl] = useState("");
    const [documentUrlPdf, setDocumentUrlPdf] = useState("");
    const [dades, setRebuts] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);


    useEffect(() => {
        handleLoadingChange(true)
        if (isLoggedIn) {
            checkDades();
        }
    }, [id, documentUrl]);

    async function checkDades() {
        await handleLoadingChange(true);
        const dades = await GetRemeses(page);
        setRebuts(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function deleteElement(id: 0) {
        await handleLoadingChange(true);
        await DeleteRemesa(id, page);
        checkDades();
    }

    async function downloadDocument(id: string) {
        const documentUrl = await PostRemesaDocument(id, page, token);
        await setDocumentUrl(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `remesa${id}.xml`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    async function factura(s: number) {
        const documentUrl = await PostRemesaFactura(s, page, token);
        setDocumentUrlPdf(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    const columns: ColumnsType<RebutAlgoritmixModel> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nomEmpresa',
            title: 'Empresa',
            dataIndex: 'nomEmpresa',
            width: 30
        },
        {
            key: 'iban',
            title: 'IBAN',
            dataIndex: 'iban',
            responsive: ['lg'],
            width: 30
        },
        {
            key: 'sepa',
            title: 'SEPA',
            dataIndex: 'sepa',
            responsive: ['lg'],
            width: 30
        },
        {
            key: 'total',
            title: 'Total rebut',
            dataIndex: 'total',
            width: 30
        },
        {
            key: 'assumpte',
            title: 'Assumpte',
            dataIndex: 'assumpte',
            width: 30
        },
        {
            key: 'alta',
            title: 'Data Alta',
            dataIndex: 'alta',
            responsive: ['lg'],
            width: 30
        },
        {
            key: 'dataFacturacio',
            title: 'Data Facturació',
            dataIndex: 'dataFacturacio',
            width: 30
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 50,
            render: (estat, ele) => (
                <>
                    <Popconfirm
                        title="Eliminant"
                        description="Vols eliminar definitivament aquest element?"
                        onConfirm={() => deleteElement(ele.id)}
                        icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                    >
                        <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color3}}><BiTrash/></Button>
                    </Popconfirm>
                    {" "}
                    <Button title={"Descarregar Remesa"} onClick={() => downloadDocument(ele.id + "")}
                            style={{backgroundColor: Colors.colors.color4}}><BsFilePdf/></Button>
                    {" "}
                    <Button title={"Generar Factura"} onClick={() => factura(ele.id)}
                            style={{backgroundColor: Colors.colors.color5}}><BsCurrencyEuro/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<RebutAlgoritmixModel> = {
        loading
    };

    const onChange: TableProps<RebutAlgoritmixModel>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    if (isLoggedIn) {
        return (
            <div>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <Button title={"Tornar a pujar fitxer"}
                                style={{backgroundColor: Colors.colors.color4}}
                                onClick={checkDades}>
                            <BiRefresh/>
                        </Button>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                pagination={{pageSize: 100}}
                                scroll={{y: 400}}
                                dataSource={dades}
                            />
                        )}
                    </Card>
                    <br/>
                    {/*<CarregaAlgoritmix checkDadesAlg={checkDades}/>
                    <br/>*/}
                    <Historials pantalla={"ALGORITMIX"} pagina={page}/>
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Remeses;
